import React, {Component} from 'react';
import styles from './Button.less';

class Button extends Component {
	render() {
		const {view_type, className, children, icon, ...props} = this.props;
		const {
			button: buttonClass,
			button__icon: iconClass,
			button__text: textClass
		} = styles;
		const classes = [className, buttonClass];

		if (['link'].includes(view_type)) {
			classes.push(styles['button_' + view_type]);
		}

		return (
			<button className={classes.join(' ')} {...props}>
				{icon && (
					<span className={iconClass}>{icon}</span>
				)}
				<span className={textClass}>{children}</span>
			</button>
		);
	}
}

export default Button;